<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <c-card title="Editar semáforo">
          <semaforo-form />
        </c-card>
      </div>
    </div>
  </div>
</template>
<script>
import SemaforoForm from "@/components/Forms/SemaforoForm.vue";
import CCard from "@/components/CCard.vue";
export default {
  components: {
    SemaforoForm,
    CCard,
  },
};
</script>
